import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { SortDirection } from '@railmybox/shared/util';
import { AdminStationSearchParamModel, ChangeEntryModel, LoadpointModel, StationModel } from '@railmybox/api-booking';
import { StationOperatorModel } from '@railmybox/api-dispo';
import { StationStorageModel, StationSurchargeModel } from '@railmybox/api-pricing';

export type StationsSortKeys = 'active' | 'name' | 'code' | 'unLoCode' | 'trucking' | 'combinedCapacity' | 'sea';

export interface StationsState extends EntityState<StationModel> {
  fees: StationStorageModel[];
  historyLogs: ChangeEntryModel[];
  loadpoints: LoadpointModel[];
  operatorCodes: StationOperatorModel[];
  additionalSurcharges: StationSurchargeModel[];
  filters: AdminStationSearchParamModel;
  offset?: number;
  limit?: number;
  ui: {
    sortBy: StationsSortKeys;
    sortDirection: SortDirection;
    valueGetterFn?: (data: StationModel) => string;
  };
  activeStation: StationModel;
  disableSaveBtn: boolean;
  loadingSaveButton: boolean;
  disbledPrevBtn?: boolean;
  disbledNextBtn?: boolean;
}

function createInitialState(): Partial<StationsState> {
  return {
    fees: [],
    loadpoints: [],
    operatorCodes: [],
    additionalSurcharges: [],
    ui: {
      sortBy: 'name',
      sortDirection: SortDirection.ASC,
    },
    filters: {
      query: '',
    },
    offset: 0,
    limit: 50,
    disableSaveBtn: true,
    loadingSaveButton: false,
    disbledPrevBtn: false,
    disbledNextBtn: false,
  };
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'master-stations', resettable: true })
export class StationsStore extends EntityStore<StationsState> {
  constructor() {
    super(createInitialState());
  }
}
